<div class="full-background" *ngIf="isVisible">
  <div class="prize-won">
    <p style="text-align: right;">EXME - Ganhaste um prémio<ion-button slot="end" (click)="closePrize()" size="small">{{ 'CLOSE' | translate}}</ion-button></p>
    <div class="prize-won-flex">
    <!--ion-button slot='end' (click)="toogleDisplayingImpression()">Fechar já</ion-button-->
    <img src={{prizeImage}} />
    <div class="prize-won-block">
      <p>{{prizeDescription}}</p>
      <!--p><a href={{advertizementURL}} target="_blank">{{advertizementURLText}}</a></p-->
      <p button (click)="openPrizeWithSystemBrowser(prizeURL)" >
        <ion-icon color="white" slot="start" name="rocket-outline"></ion-icon>
        <ion-label>{{prizeURLText}}</ion-label>
      </p>

    </div>
  </div>
  </div>
</div>